import { HStack, VStack } from "@chakra-ui/react";
import { DisabledByDefault as DisalbeIcon } from "@mui/icons-material";
import { Form, Formik } from "formik";
import { FC, useCallback } from "react";

import { SymbolSolidButton } from "~/src/components/common/Button";
import { FormControl } from "~/src/components/common/forms/FormControl";
import { FormikFormButtons } from "~/src/components/common/forms/FormikFormButtons";
import {
  FormikMultipleSelectField,
  FormikMultipleSelectFieldProps,
} from "~/src/components/common/forms/FormikMultipleSelectField";
import { Modal } from "~/src/components/common/Modal";
import { useOpenState } from "~/src/lib/hooks";

export type FormValues = {
  disableColumns: number[];
};

export type Props = {
  formValues: FormValues;
  onSubmit: (formValues: FormValues) => Promise<void> | void;
  options: FormikMultipleSelectFieldProps["options"];
};

export const DisableColumnSelectButton: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ formValues, onSubmit, options }) => {
  const { isOpen, onClose, onOpen } = useOpenState();

  const handleSubmit = useCallback(
    (values: FormValues) => {
      onSubmit(values);
      onClose();
    },
    [onClose, onSubmit]
  );

  return (
    <HStack>
      <SymbolSolidButton
        size="24px"
        icon={<DisalbeIcon />}
        isActive={isOpen}
        onClick={onOpen}
      >
        表示しない項目の選択
      </SymbolSolidButton>
      <Modal title="フィルタ" isOpen={isOpen} onClose={onClose}>
        <Formik<FormValues>
          enableReinitialize
          initialValues={formValues}
          validateOnMount={false}
          validateOnChange={false}
          onSubmit={handleSubmit}
        >
          <Form>
            <VStack spacing="16px">
              <FormControl label={"表示しない項目"}>
                <FormikMultipleSelectField
                  name="disableColumns"
                  options={options}
                />
              </FormControl>
            </VStack>
            <FormikFormButtons onCancelClick={onClose} />
          </Form>
        </Formik>
      </Modal>
    </HStack>
  );
};
